import React from 'react';
import PropTypes from 'prop-types';
import CompactCurrencyFilter from '../product/PricingUtils';
import CartInviteSubItem from './CartInviteSubItem';
import DateRange from '../product/DateRange';

const CartInvites = ({ item, removeItems }) => (
  <div className="cart-item">
    <div className="row">
      <span className="close visible-xs-block" onClick={() => removeItems(item.suiteProductIds)}>&times;</span>
      <div className="item-description-col col-xs-11 col-sm-6">
        <div className="shop-entity-details">
          <div className="entity-name">{item.name}</div>
          {/* <!-- sku attributes and availability info --> */}
          <div className="cart-item-attributes">
            {item.availability.arrivalRange && <div className="value-label"><strong>Estimated Arrival:</strong> <DateRange dateRange={item.availability.arrivalRange} /></div>}
          </div>
        </div>
        {/* <!-- shipping alert --> */}
        {item.availability.isExpeditable && <div className="cart-item-discount">Two-day shipping available</div>}
        {/* <!-- discounts --> */}
        {item.discounts.map(discount =>
          <div key={discount} className="cart-item-discount">{discount}</div>
        )}
        {item.showExcludeFromPromo && <div className="cart-item-discount">Excluded from Promo</div>}
        {/* <!-- shipping exclusions --> */}
        {item.exclusionFlag && <div className="cart-item-exclusion text-red bold">{item.exclusionMessage}</div>}
      </div>
      <div className="shop-entity-details hidden-xs col-sm-2">
        <div className="price">
          {CompactCurrencyFilter(item.adjustedPrice)}&nbsp;
          {item.price > item.adjustedPrice && <s className="small text-muted" >{CompactCurrencyFilter(item.price)}</s>}
        </div>
      </div>
      <div className="clearfix visible-xs-block" />
      <div className="col-xs-6 col-sm-2 cart-item-quantity">
        <div className="form-group-inline">
          <label htmlFor={`cart-qty-${item.id}`} className="control-label visible-xs-inline-block">Quantity:</label>
          <div>
            <input
              className="form-control input-narrow"
              id={`cart-qty-${item.id}`}
              disabled="true"
              type="number"
              required
              min="1"
              max="400"
              step="1"
              value={item.quantity}
            />
            <a role="button" className="text-large hidden-xs" onClick={() => removeItems(item.suiteProductIds)}>Remove</a>
          </div>
        </div>
      </div>
      <div className="col-xs-6 col-sm-2 cart-item-subtotal">
        <strong className="text-danger">{CompactCurrencyFilter(item.subtotal)}</strong>
      </div>
    </div>
    <div>
      {item.childItems.map(childItem => <CartInviteSubItem key={childItem.id} item={childItem} />)}
    </div>
  </div>
);

CartInvites.propTypes = {
  item: PropTypes.shape({}),
  removeItems: PropTypes.func.isRequired
};

export default CartInvites;



/** WEBPACK FOOTER **
 ** ./src/components/cart/CartInvites.jsx
 **/